<template>
  <div class="modal-content ion-padding ion-text-center">
    <modal-close />
    <roodie fillOuter="#5E58BE" :expression="'happy'" />
    <div class="u-color-primary">
      <!-- <div class="u-medium ion-margin-top u-bold">
        Medgate Arztgespräch
      </div>
      <div class="ion-margin-top">
        <ion-icon style="font-size: 96px" :icon="videocam"></ion-icon>
      </div> -->
      <p>
        <b
          >Ihr digitaler Arztbesuch wird von Medgate, dem Spezialisten für
          Fernbehandlungen, ausgeführt.</b
        >
      </p>
      <p>
        Zu Ihrem Schutz bedarf es einer gesonderten Anmeldung hierfür in der App
        von
        <!-- <a
          href="#"
          @click.prevent="
            $router.push({
              name: 'medgate',
              params: { from: 'contact' },
            });
            modalController.dismiss();
          "
          >Medgate</a
        > -->
        Medgate - wir leiten Sie gleich direkt weiter.
      </p>
      <p>
        Bitte beachten Sie, dass durch die Weiterleitung an Medgate dieser
        bekannt wird, dass für Sie eine Krankenversicherung bei der ARAG
        besteht.
      </p>
      <ion-button
        class="ion-margin-top gtm-video-medgate"
        fill="outline"
        @click="
          browser.open({
            url: 'https://www.medgate.ch/en-us/for-patients/medgate-app',
          })
        "
        >Weiter</ion-button
      >
      <!-- <ion-item lines="none">
        <ion-checkbox slot="start" v-model="privacy1"> </ion-checkbox>
        <ion-label class="ion-text-wrap" color="primary">
          Ich möchte die Fernbehandlung von Medgate nutzen und
          <u
            ><a href="#" @click.prevent="openInfoModal(privacy1Text)"
              >stimme der Verarbeitung meiner personenbezogenen Daten
            </a></u
          >
          hierfür durch Medgate zu.
        </ion-label>
      </ion-item> -->
      <!-- <ion-button
        class="ion-margin-top gtm-video-medgate"
        fill="outline"
        :disabled="!privacy1"
        >Weiter</ion-button
      > -->
    </div>
  </div>
</template>

<script>
import Roodie from "@lib/components/svg/Roodie";
import {
  IonButton,
  // IonIcon,
  // IonItem,
  // IonCheckbox,
  // IonLabel,
  modalController,
} from "@ionic/vue";
import { videocam } from "ionicons/icons";
import ModalClose from "@lib/components/ModalClose";
import InfoModal from "@lib/components/InfoModal";
import { Browser } from "@capacitor/browser";

export default {
  components: {
    Roodie,
    IonButton,
    // IonIcon,
    ModalClose,
    // IonItem,
    // IonCheckbox,
    // IonLabel,
  },
  setup() {
    return { videocam, modalController };
  },
  data() {
    return {
      window: window,
      privacy1: false,
      privacy1Text:
        "<p>Ihre angegebenen Daten (Anrede, Vorname, Nachname, PLZ, E-Mail-Adresse, Telefonnummer) werden im Zuge der Vertragserfüllung an Medgate, weitergeleitet und von Medgate für die Registrierung gespeichert und verarbeitet. Die Rechtsgrundlage iSd Datenschutz-Grundverordnung (DSGVO) ist hierbei Art 6 Abs 1 lit b DSGVO.</p>",
      browser: Browser,
    };
  },
  methods: {
    async openInfoModal(text) {
      const modal = await modalController.create({
        component: InfoModal,
        cssClass: "my-custom-class",
        componentProps: {
          title: "Datenschutzbestimmungen",
          text: text,
        },
      });
      return modal.present();
    },
  },
};
</script>

<style></style>
